import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';

import Utils from '../shared/utility';

@Component({
  selector: 'app-long-term-care',
  templateUrl: './long-term-care.component.html',
  styleUrls: ['./long-term-care.component.css']
})
export class LongTermCareComponent implements OnInit {

  constructor(public route: ActivatedRoute, public globalService: GlobalService, public modalService: ModalService, public snackBarService: SnackBarService, public router: Router, public loadingService: LoadingService) {
    modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        //console.log('ZSS model closed');
        this.hasRiskTolBeenRan = false;
        this.getClient();
      }
    });
  }

  @ViewChild('p1Percent') p1Percent: ElementRef;
  @ViewChild('p1EndAge') p1EndAge: ElementRef;
  @ViewChild('p2Percent') p2Percent: ElementRef;
  @ViewChild('p2EndAge') p2EndAge: ElementRef;
  @ViewChild('p3Percent') p3Percent: ElementRef;
  @ViewChild('annualEl') annualEl: ElementRef;
  
  public pocMessage: string = "The length, in years, that the client will require long-term care services.";
  public mrMessage: string =  "Costs can vary within each state, so selecting the metro area will provide a more accurate expense projection.";
  public loaMessage: string =  "Skilled Nursing: Retirement community with professionals providing help with Activities of Daily Living (ADLs) on a regular basis. Assisted Living: Retirement community but with more individual freedom and less reliance on assistance. Home Health Care: Professionals administer care in the client’s home.";
  public fsMessage: string = "Add any expected income which is earmarked to healthcare cost funding in the inputs below. Contributions will diminish remaining unfunded costs.";
 
  public tptMessage: string =  "Projected lifetime household cost for long-term care needs, after incorporating a 3% annual inflation adjustment so as to show costs in the net present value.";
  public tpfMessage: string =  "Total cost of long-term care that is needed, according to projections. Note that this may cover more (or less) than one year of coverage, according to the selection made for Period of Care.";
  public tpfcMessage: string =  "One-time investment value required today, based on rates of return indicated below, to fund household lifetime LTC needs.";
  //old: public tpfMessage: string =  "Projected lifetime household cost for long-term care needs, show in the future value.";

  public eacMessage: string = "Current annual cost for the select care setting this year (this will not be your actual cost).";
  //old: public eacMessage: string =  "Projected lifetime household cost for long-term care needs, show in the future value.";
  public pacMessage: string =  "One year of cost in the year that long-term care is first needed, according to projections.";
  public tpcMessage: string =  "Total cost of long-term care that is needed, according to projections. Note that this may cover more (or less) than one year of coverage, according to the selection made for Period of Care.";
  public naMessage: string = "";
  
  public error: any;
  public client: any;
  public partnerActive: boolean;

  public fundingItems: any[] = [];
  public totalRemainingGap: number = 0;
  public beginningBalance: number;

  public response: any = {};

  public clientRegions: any;
  public spouseRegions: any;

  public riskToleranceEnabled = false;

  public selfPeriods: number = 12;
  public selfRegion: number = 0;
  public selfType: number = 1;

  public spousePeriods: number = 12;
  public spouseRegion: number = 0;
  public spouseType: number = 1;

  public futureWeeklyTotal: number = 0;

  public pieChartData: any[];
  public barChartData: any[];
  futureTotalCost;

  public lineChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: true,
    xAxisLabel: '',
    yAxisLabel: '',
    roundDomains: true,
    colorScheme: {
      domain: ['#bad052', '#bad052', '#bad052']
    },
    autoScale: true
  }

  public pieChartOptions = {
    showLegend: false,
    colorScheme: { domain: ['#bad054','#eaf0cb', '#e3ecba', '#dce7a9', '#d5e298', '#cede87', '#c7d976', '#c0d465'] },
    showLabels: false,
    explodeSlices: false,
    doughnut: false,
    view: [500, 250],
    autoScale: true
  }

  public barChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,
    xAxisLabel: 'Country',
    showYAxisLabel: false,
    roundEdges: false,
    yAxisLabel: 'Population',
    colorScheme: {
      domain: ['#e8f0c7', '#d3e08e', '#bad054']
    }
  }

  public portfolioRecommendationObject: any = {
    year: ' ',
    phase1Val: ' ',
    phase2Val: ' ',
    clientAge: ' ',
    spouseAge: ' ',
    singleInvestment: ' ',
    unfundedAmount: ' ',
    spouseFirstName: '',
    spouseLastName: '',
    ltcReport: '',
    user: ''
  }

  public fundingSource: any = ''
  public startAge: any =''
  public endAge: any = ''
  public inflationRate: any = ''
  public annContribution: any = ''
  showFundingBorder: boolean;
  showStartAgeBorder: boolean;
  showEndAgeBorder: boolean;
  showInflationBorder: boolean;
  showAnnContrBorder: boolean;
  isAssetManagement: boolean = false;

  currentYear = new Date().getFullYear();

  isAlreadyRetired: boolean;

  // for existing user who has the access to Risk Tolerane but still hasn't any Risk Tolerance data
  public portfolioRecommendationVisible: boolean;

  ltcReport: any;
  user: any;

  @ViewChild('FundingSource') fundingSourceInput:any;
  @ViewChild('AnnContribution') annContributionInput:any;
  @ViewChild('StartAge') startAgeInput:any;
  @ViewChild('EndAge') endAgeInput:any;
  @ViewChild('InflationRate') inflationRateInput:any;

  ngOnInit() {
    if (this.route.snapshot.queryParams['am'] == 1) {
      this.isAssetManagement = true;
    }
    
    this.getClient();
  }

  public clientYearsOfStay: number = 5;
  public spouseYearsOfStay: number = 5;

  getClient() {
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
      .subscribe(
      client => {
        this.client = client;
        this.clientYearsOfStay = Math.min(15, this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB));
        
        this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
        
        if (this.client.clientProfile.Spouses.length > 1) {
          this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
        }
        
        if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
          this.partnerActive = true;
          this.spouseYearsOfStay = Math.min(15, this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob));
        } else {
          this.partnerActive = false;
        }

        this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);
        if(localStorage.getItem('featRiskTolerance') != 'undefined'){
          this.riskToleranceEnabled = JSON.parse(localStorage.getItem('featRiskTolerance'));
          this.globalService.featRiskTolerance =  this.riskToleranceEnabled;
        }

        this.getLTCData(client);
      },
      error => this.error = <any>error);
  }

  

  handleNewFundingItem(fundingSource: string, annContribution: number, startAge: number, endAge: number, inflationRate: number) {
    
    if(startAge < this.currentYear){
      startAge = this.currentYear;
    }

    if(endAge < startAge || endAge > (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear){
      endAge = (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear;
    }

    
    
    var contributionAmount = this.getFutureContributionAmountV2(annContribution, endAge - startAge, inflationRate, startAge, null);
    

    this.totalRemainingGap = this.formatNumber((this.totalRemainingGap - Number(contributionAmount)));

    

    this.fundingItems.push({
      fundingSource,
      annContribution,
      startAge,
      endAge,
      inflationRate,
      contributionAmount: this.formatNumber(contributionAmount),
      remainingUnfunded: this.formatNumber(this.totalRemainingGap)
    });


    this.fundingSourceInput.nativeElement.value = '';
    this.annContributionInput.nativeElement.value = '';
    this.startAgeInput.nativeElement.value = '';
    this.endAgeInput.nativeElement.value = '';
    this.inflationRateInput.nativeElement.value = '';
    
    this.getLTCData(this.client);
  }

  generatePieChartData() {
    var tempTotal = Utils.formatToNumber(this.totalRemainingGap); // -  this.futureTotalCost - (this.hcDataV2.FundingOptions.PartB.replace(/,/g,"").replace("$",""));

    if (this.fundingItems.length) {
      tempTotal = this.fundingItems[this.fundingItems.length - 1].remainingUnfunded;
    }
    
    this.pieChartData = [
      { "name": "Unfunded", "value": tempTotal }
    ]
    this.fundingItems.forEach((item) => { this.pieChartData.push({ "name": item.fundingSource, "value": item.contributionAmount })});
  }

  public expectedLE: any;

  getLTCData(client,includeSingleInvestment?: any) {
    const isMarried = client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;

    var investmentItems = [];
    var currentAge = this.calculateAge(client.client.DOB);
    var currentYear = new Date().getFullYear();


    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        // Begins: (this.fundingItems[item].startAge - currentAge) + currentYear,
        Begins: this.fundingItems[item].startAge,// + currentYear,
        Ends: this.fundingItems[item].endAge,// - currentAge) + currentYear,
        StartAmount: this.fundingItems[item].annContribution,
        // Ends: (this.fundingItems[item].endAge - currentAge) + currentYear,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    const ltc = {
      investmentItems: JSON.stringify({ investmentItems }),
      FrmHasPartner: isMarried,
      FrmName0: client.client.FirstName + ' ' + client.client.LastName,
      FrmName1: isMarried ? client.clientProfile.Spouses[0].firstName + ' ' + client.clientProfile.Spouses[0].lastName : '',
      FrmGender0: client.client.GenderID,
      FrmCurrentAge0: this.calculateAge(client.client.DOB),
      FrmGender1: isMarried ? Number(client.clientProfile.Spouses[0].gender) : 0,
      FrmCurrentAge1: isMarried ? this.calculateAge(client.clientProfile.Spouses[0].dob) : 0,
      FrmLTCState0: client.clientProfile.UseNationalAverage ? '' : client.clientProfile.RetirementState,
      FrmHealth0: 0,
      FrmHealth1: 0,
      FrmLTCState1: isMarried ? (client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses[0].state) : '',

      // FrmPhase1Rate: this.riskToleranceEnabled ? (this.portfolioRecommendationObject.phase1Val > 0 ? Number(this.portfolioRecommendationObject.phase1Val) : 6) : (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
      // FrmPhase1Periods: this.riskToleranceEnabled ? this.getPhaseDiff(1) : (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      // FrmPhase2Rate: this.riskToleranceEnabled ? (this.portfolioRecommendationObject.phase2Val > 0 ? Number(this.portfolioRecommendationObject.phase2Val) : 6) : (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
      // FrmPhase2Periods: this.riskToleranceEnabled ? this.getPhaseDiff(2) : (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      // FrmPhase3Rate: this.riskToleranceEnabled ? (this.portfolioRecommendationObject.phase2Val > 0 ? Number(this.portfolioRecommendationObject.phase2Val) : 6) : (this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6),

      FrmPhase1Rate: (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
      FrmPhase1Periods: (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      FrmPhase2Rate:  (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
      FrmPhase2Periods: (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      FrmPhase3Rate: (this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6),

      FrmLTCMonths0: this.selfPeriods,
      FrmLTCMonths1: this.spousePeriods,
      
      FrmPlanningAge0: this.client.clientProfile.LifeExpectancy,
      FrmPlanningAge1: isMarried ?  Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,

      MetroRegion0: this.selfRegion, // here
      MetroRegion1: this.spouseRegion,

      InvestmentYears: this.isAssetManagement ? 1 : (Number(this.annualEl.nativeElement.value)),
      InvestmentOption: this.investmentOption,

      CareType: this.selfType,
      CareType1: this.spouseType,

      //HACK: added for backwards compatibility
      ClientCareTypes: [{ careType: this.selfType, lengthOfCare: this.selfPeriods }],
      SpouseCareTypes: [{ careType: this.spouseType, lengthOfCare: this.spousePeriods }]
    }

    

    const queryInfo = {
      clientID: client.client.ID,
      userID: client.client.AdvisorID,
      orgID: client.client.OrganizationID,
      clientRetirementAge: client.clientProfile.RetirementAge
    }

    if (includeSingleInvestment && this.isAlreadyRetired){
      ltc.FrmPhase2Rate = ltc.FrmPhase1Rate;
      ltc.FrmPhase2Periods = Number(this.client.clientProfile.LifeExpectancy) - Number(this.client.clientProfile.RetirementAge);
      ltc.FrmPhase3Rate = ltc.FrmPhase1Rate;
    }
    this.ltcReport = ltc;
    this.user = queryInfo;
    this.globalService.getLTCData(ltc, queryInfo)
    .subscribe(
      data => {
        this.response = data;
          this.totalRemainingGap = this.totalRemainingGap ? (this.totalRemainingGap < 0 ? 0 : this.totalRemainingGap) :  Utils.formatToNumber(this.response.depositedToday.toFixed(0));
          this.beginningBalance = this.response.initialInvestment;
          
          this.response.depositedToday = Utils.formatToCurrency(this.response.depositedToday.toFixed(0));
          this.response.annualNumber = Utils.formatToCurrency(this.response.annualNumber.toFixed(0));
          this.response.weeklyNumber = Utils.formatToCurrency(this.response.weeklyNumber.toFixed(0));
          this.response.totalFutureNumber = Utils.formatToCurrency(this.response.totalFutureNumber.toFixed(0));
          
  
          this.clientRegions = this.response.regionExpenses.Rows.splice(1, this.response.regionExpenses.Rows.length);
          this.spouseRegions = isMarried ? this.response.regionExpenses1.Rows.splice(1, this.response.regionExpenses1.Rows.length) : [];
  
          this.client && this.client.clientProfile ? this.client.clientProfile.LifeExpectancy : '--'
  
          this.expectedLE = this.client.clientProfile.LifeExpectancy;

          this.futureTotalCost = Number(this.response.totalFutureNumber.toString().replace(/,/g, "").replace("$", ""));
          //this.totalSocialSecurity = Number(this.hcDataV2.FundingOptions.PartB.toString().replace(/,/g, "").replace("$", ""));

          this.currentRemainingTotalForRiskTolPort = this.futureTotalCost;// - this.totalSocialSecurity;
  
          if (isMarried) {
            this.expectedLE = this.client.clientProfile.LifeExpectancy > this.client.clientProfile.Spouses[0].LifeExpectancy ? this.client.clientProfile.LifeExpectancy : this.client.clientProfile.Spouses[0].LifeExpectancy;
          }
  
          if (includeSingleInvestment) {
            this.portfolioRecommendationObject.singleInvestment = this.response.depositedToday;
          }
          
          this.futureYearlyCost =  Utils.formatToCurrency(Utils.formatToNumber(this.response.annualNumber) * (this.isAssetManagement ? 1 : this.annualEl.nativeElement.value || 10));
          this.futureWeeklyTotal =  Utils.formatToCurrency((Utils.formatToNumber(this.response.weeklyNumber) * 52) * (this.isAssetManagement ? 1 : this.annualEl.nativeElement.value || 10));
  
          this.generatePieChartData();
          this.generateBarChartData();

          this.getPortfolioRecommendation();
      },
      error => this.error = <any>error);  
  }

  public futureYearlyCost: any = 0;

  handleEditClientModal(e) {
    this.modalService.add('add-edit-client', { ID: this.client.client.ID });
  }

  getFutureContributionAmountV2(startAmount, years, inflation, startAge, idx) {
    var result = 0;

    for (let i = 0; i < years + 1; i++) {
      result = result + (startAmount * Math.pow((1 + inflation / 100), i));
    }

    return result;
  }

  formatNumber(amount) {
    return Math.round(amount);
  }

  removeFundingItem(item) {
    this.fundingItems.splice(this.fundingItems.indexOf(item), 1);
    this.onRateChange();
  }

  onRateChange(percentValue = {value:0}) {
    this.hasRiskTolBeenRan = false;
    this.getLTCData(this.client);
    
    if(percentValue != undefined){
      if(percentValue.value > 12){
        return percentValue.value = 12;
      }
    }
  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  calcAnnualSavings(el, el2) {
    el2.value = el.value;
    this.hasRiskTolBeenRan = false;
    this.getLTCData(this.client);
  }

  calcWeeklySavings(el) {
    // el.value = el2.value;
    this.hasRiskTolBeenRan = false;
    this.getLTCData(this.client);
  }



  handleIllustrationModal(e) {


    // var projectedYears = this.hcDataV2.Illustrations.map(entry => {
    //   return {
    //     Year: 2018,
    //     BeginningBalance: '$' + (entry.BeginningBalance ? entry.BeginningBalance.toFixed(0) : 0),
    //     ExpectedRateReturn: (entry.CashFlowEntry.ExpectedRor ? entry.CashFlowEntry.ExpectedRor * 100 + '%': 0),
    //     Premiums: '$' + 0,
    //     Contribution: '$' + (entry.CashFlowEntry.TotalIncome ? entry.CashFlowEntry.TotalIncome.toFixed(0) : 0),
    //     AdditionalCosts: '$' + 0,
    //     Total: '$' + (entry.CashFlowEntry.Expense ? entry.CashFlowEntry.Expense.toFixed(0) : 0),
    //     NetOfSSDeductions: '$' + 0,
    //     EngingBalance: '$' + (entry.EndingBalance ? entry.EndingBalance.toFixed(0) : 0),
    //   }
    // });

    this.modalService.add('ltc-projections', { Data: this.response.IllustrationBody });
  }

  public cowValues: any = {
    one: 0,
    three: 0,
    five: 0,
  };

  generateBarChartData() {

    this.cowValues.one = this.response.costOfWaitingToday ? Utils.formatToCurrency(this.response.costOfWaitingToday.toFixed(0)) : 0;
    this.cowValues.three = this.response.costOfWaitingThree && this.response.costOfWaitingToday >= 1  ? Utils.formatToCurrency(this.response.costOfWaitingThree.toFixed(0)) : 0;
    this.cowValues.five = this.response.costOfWaitingFive && this.response.costOfWaitingToday >= 1 ? Utils.formatToCurrency(this.response.costOfWaitingFive.toFixed(0)) : 0;
    
    this.barChartData = [
      {
        "name": "Today",
        "value": this.response.costOfWaitingToday
      },
      {
        "name": "3 Years",
        "value": this.response.costOfWaitingToday < 1 ? 0 : this.response.costOfWaitingThree
      },
      {
        "name": "5 Years",
        "value": this.response.costOfWaitingToday < 1 ? 0 : this.response.costOfWaitingFive
      }
    ]
  }

  handleSavingLTCRiskTolerance() {
    var Report = {
      ClientID: this.client.client.ID,
      AdvisorID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID,
      ReportTypeID: 7,
    }


    const isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;

    var client = this.client;

    var investmentItems = [];
    var currentAge = this.calculateAge(client.client.DOB);
    var currentYear = new Date().getFullYear();

    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,// + currentYear,
        Ends: this.fundingItems[item].endAge,// - currentAge) + currentYear,
        // Begins: (this.fundingItems[item].startAge - currentAge) + currentYear,
        StartAmount: this.fundingItems[item].annContribution,
        // Ends: (this.fundingItems[item].endAge - currentAge) + currentYear,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    var ReportLTC = {
      investmentItems: JSON.stringify({ investmentItems }),
      FrmHasPartner: isMarried,
      FrmName0: client.client.FirstName + ' ' + client.client.LastName,
      FrmName1: isMarried ? client.clientProfile.Spouses[0].firstName + ' ' + client.clientProfile.Spouses[0].lastName : '',
      FrmGender0: client.client.GenderID,
      FrmCurrentAge0: this.calculateAge(client.client.DOB),
      FrmGender1: isMarried ? Number(client.clientProfile.Spouses[0].gender) : 0,
      FrmCurrentAge1: isMarried ? this.calculateAge(client.clientProfile.Spouses[0].dob) : 0,
      FrmLTCState0: client.clientProfile.UseNationalAverage ? '' : client.clientProfile.RetirementState,
      FrmHealth0: 0,
      FrmHealth1: 0,
      FrmLTCState1: isMarried ? (client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses[0].state) : '',

      FrmPhase1Rate: (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
      FrmPhase1Periods: (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      FrmPhase2Rate: (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
      FrmPhase2Periods: (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      FrmPhase3Rate: (this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6),

      FrmLTCMonths0: this.selfPeriods,
      FrmLTCMonths1: this.spousePeriods,
      
      FrmPlanningAge0: this.client.clientProfile.LifeExpectancy,
      FrmPlanningAge1: isMarried ?  Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,

      MetroRegion0: this.selfRegion, // here
      MetroRegion1: this.spouseRegion,

      MetroRegionDesc0: this.getRegionDescription(this.client.clientProfile.RetirementState, this.selfRegion, true),
      MetroRegionDesc1: this.getRegionDescription(isMarried ? this.client.clientProfile.Spouses[0].state : '', this.spouseRegion, false),

      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,

      InvestmentYears: (Number(this.annualEl.nativeElement.value)),
      InvestmentOption: this.investmentOption,

      CareType: this.selfType,
      CareType1: this.spouseType,

      //HACK: added for backwards compatibility
      ClientCareTypes: [{ careType: this.selfType, lengthOfCare: this.selfPeriods }],
      SpouseCareTypes: [{ careType: this.spouseType, lengthOfCare: this.spousePeriods }],

      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQHighCholesterol: this.client.clientProfile.HCHC,
      FrmQHBP: this.client.clientProfile.HCHBP,

      SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQHighCholesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
    }
    this.globalService.createReportLTC(Report, ReportLTC)
      .subscribe(
      resp => {
        this.snackBarService.add("Please wait while your long-term care report is being generated.", 0);
        //this.router.navigateByUrl('/reports/create?d=t');
        this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
      },
      error => this.error = <any>error);
  }

  handleSavingLTC() {

    var Report = {
      ClientID: this.client.client.ID,
      AdvisorID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID,
      ReportTypeID: 4,
    }


    const isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;

    var client = this.client;

    var investmentItems = [];
    var currentAge = this.calculateAge(client.client.DOB);
    var currentYear = new Date().getFullYear();

    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,// + currentYear,
        Ends: this.fundingItems[item].endAge,// - currentAge) + currentYear,
        // Begins: (this.fundingItems[item].startAge - currentAge) + currentYear,
        StartAmount: this.fundingItems[item].annContribution,
        // Ends: (this.fundingItems[item].endAge - currentAge) + currentYear,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    var ReportLTC = {
      investmentItems: JSON.stringify({ investmentItems }),
      FrmHasPartner: isMarried,
      FrmName0: client.client.FirstName + ' ' + client.client.LastName,
      FrmName1: isMarried ? client.clientProfile.Spouses[0].firstName + ' ' + client.clientProfile.Spouses[0].lastName : '',
      FrmGender0: client.client.GenderID,
      FrmCurrentAge0: this.calculateAge(client.client.DOB),
      FrmGender1: isMarried ? Number(client.clientProfile.Spouses[0].gender) : 0,
      FrmCurrentAge1: isMarried ? this.calculateAge(client.clientProfile.Spouses[0].dob) : 0,
      FrmLTCState0: client.clientProfile.UseNationalAverage ? '' : client.clientProfile.RetirementState,
      FrmHealth0: 0,
      FrmHealth1: 0,
      FrmLTCState1: isMarried ? (client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses[0].state) : '',
      
      FrmPhase1Rate: (Number(this.p1Percent.nativeElement.value)),
      FrmPhase1Periods: Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB),
      FrmPhase2Rate: (Number(this.p2Percent.nativeElement.value)),
      FrmPhase2Periods: (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))),
      FrmPhase3Rate: (Number(this.p3Percent.nativeElement.value)),

      FrmLTCMonths0: this.selfPeriods,
      FrmLTCMonths1: this.spousePeriods,
      
      FrmPlanningAge0: this.client.clientProfile.LifeExpectancy,
      FrmPlanningAge1: isMarried ?  Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,

      MetroRegion0: this.selfRegion, // here
      MetroRegion1: this.spouseRegion,

      MetroRegionDesc0: this.getRegionDescription(this.client.clientProfile.RetirementState, this.selfRegion, true),
      MetroRegionDesc1: this.getRegionDescription(isMarried ? this.client.clientProfile.Spouses[0].state : '', this.spouseRegion, false),

      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,

      InvestmentYears: (Number(this.annualEl.nativeElement.value)),
      InvestmentOption: this.investmentOption,

      CareType: this.selfType,
      CareType1: this.spouseType,

      //HACK: added for backwards compatibility
      ClientCareTypes: [{ careType: this.selfType, lengthOfCare: this.selfPeriods }],
      SpouseCareTypes: [{ careType: this.spouseType, lengthOfCare: this.spousePeriods }],

      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQHighCholesterol: this.client.clientProfile.HCHC,
      FrmQHBP: this.client.clientProfile.HCHBP,

      SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQHighCholesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,

    }
    console.log('ReportLTC');
    console.log(ReportLTC);
    this.globalService.createReportLTC(Report, ReportLTC)
      .subscribe(
      resp => {
        this.snackBarService.add("Please wait while your long-term care report is being generated.", 0);
        //this.router.navigateByUrl('/reports/create?d=t');
        this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
      },
      error => this.error = <any>error);

  }

  getLTCPDFValues(){
    var Report = {
      ClientID: this.client.client.ID,
      AdvisorID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID,
      ReportTypeID: 4,
      clientRetirementAge: this.client.clientProfile.RetirementAge
    }


    const isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;

    var client = this.client;

    var investmentItems = [];
    var currentAge = this.calculateAge(client.client.DOB);
    var currentYear = new Date().getFullYear();

    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,// + currentYear,
        Ends: this.fundingItems[item].endAge,// - currentAge) + currentYear,
        // Begins: (this.fundingItems[item].startAge - currentAge) + currentYear,
        StartAmount: this.fundingItems[item].annContribution,
        // Ends: (this.fundingItems[item].endAge - currentAge) + currentYear,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    var ReportLTC = {
      investmentItems: JSON.stringify({ investmentItems }),
      FrmHasPartner: isMarried,
      FrmName0: client.client.FirstName + ' ' + client.client.LastName,
      FrmName1: isMarried ? client.clientProfile.Spouses[0].firstName + ' ' + client.clientProfile.Spouses[0].lastName : '',
      FrmGender0: client.client.GenderID,
      FrmCurrentAge0: this.calculateAge(client.client.DOB),
      FrmGender1: isMarried ? Number(client.clientProfile.Spouses[0].gender) : 0,
      FrmCurrentAge1: isMarried ? this.calculateAge(client.clientProfile.Spouses[0].dob) : 0,
      FrmLTCState0: client.clientProfile.UseNationalAverage ? '' : client.clientProfile.RetirementState,
      FrmHealth0: 0,
      FrmHealth1: 0,
      FrmLTCState1: isMarried ? (client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses[0].state) : '',
      
      FrmPhase1Rate: (Number(this.isAssetManagement ? 1 : this.p1Percent.nativeElement.value)),
      FrmPhase1Periods: Number(this.isAssetManagement ? 1 : this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB),
      FrmPhase2Rate: (Number(this.isAssetManagement ? 1 : this.p2Percent.nativeElement.value)),
      FrmPhase2Periods: (Number(this.isAssetManagement ? 1 : this.p2EndAge.nativeElement.value) - (Number(this.isAssetManagement ? 1 : this.p1EndAge.nativeElement.value))),
      FrmPhase3Rate: (Number(this.isAssetManagement ? 1 : this.p3Percent.nativeElement.value)),

      FrmLTCMonths0: this.selfPeriods,
      FrmLTCMonths1: this.spousePeriods,
      
      FrmPlanningAge0: this.client.clientProfile.LifeExpectancy,
      FrmPlanningAge1: isMarried ?  Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,

      MetroRegion0: this.selfRegion, // here
      MetroRegion1: this.spouseRegion,

      MetroRegionDesc0: this.getRegionDescription(this.client.clientProfile.RetirementState, this.selfRegion, true),
      MetroRegionDesc1: this.getRegionDescription(isMarried ? this.client.clientProfile.Spouses[0].state : '', this.spouseRegion, false),

      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,

      InvestmentYears: (Number(this.isAssetManagement ? 1 : this.annualEl.nativeElement.value)),
      InvestmentOption: this.investmentOption,

      CareType: this.selfType,
      CareType1: this.spouseType,

      //HACK: added for backwards compatibility
      ClientCareTypes: [{ careType: this.selfType, lengthOfCare: this.selfPeriods }],
      SpouseCareTypes: [{ careType: this.spouseType, lengthOfCare: this.spousePeriods }],

      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQHighCholesterol: this.client.clientProfile.HCHC,
      FrmQHBP: this.client.clientProfile.HCHBP,

      SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQHighCholesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
    }

    return { Report, ReportLTC }
  }

  getPhaseDiff(phase) {
    const clientAge = Number(this.calculateAge(this.client.client.DOB));
    const clientRetirementAge = Number(this.client.clientProfile.RetirementAge);
    const clientLE = Number(this.client.clientProfile.LifeExpectancy);
    const spouseAge = Number(this.calculateAge(this.client.clientProfile.Spouses[0].dob)) || 0;
    const spouseRetirementAge = Number(this.client.clientProfile.Spouses[0].retirementAge) || 0;
    const spouseLE = Number(this.client.clientProfile.Spouses[0].LifeExpectancy) || 0;

    // console.log(
    //   clientAge,
    //   clientRetirementAge,
    //   clientLE,
    //   spouseAge,
    //   spouseRetirementAge,
    //   spouseLE
    // );

    if (spouseAge && spouseRetirementAge) {
      if (phase == 1)
        return Math.min(Math.max(0, clientRetirementAge - clientAge), Math.max(0, spouseRetirementAge - spouseAge));
      if (phase == 2)
        return Math.min(Math.max(0, clientLE - clientRetirementAge), Math.max(0, spouseLE - spouseRetirementAge));
    } else {
      if (phase == 1)
        return Math.max(0, clientRetirementAge - clientAge);
      if (phase == 2)
        return Math.max(0, clientLE - clientRetirementAge);
    }
  }
  
  getRegionDescription(state, code, isClient) {
    let description = "";
    let region = isClient ? this.clientRegions : this.spouseRegions;
    
    region.forEach((row) => {
      if (row.MetroRegionCode == code && row.StateCode == state)
        description = row.MetroRegion;
    });

    description = description.length ? description : "State Average";
    return description;
  }

  downloadReport(reportID, advisorID, clientID, orgID, reportTypeID) {
    this.loadingService.isLoading(true);
    var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, token: localStorage.getItem("bearer"), retirementAge: JSON.stringify(this.client.clientProfile.RetirementAge), spouseRetirementAge: this.client.clientProfile.Spouses[0].retirementAge || 0 };

    this.globalService.generateReport(ReportFields, this.client.client, ReportFields)
      .subscribe(
      resp => {
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        this.loadingService.isLoading(false);
      });
  }

  formatCurrency(val) {
    return Utils.formatToCurrency(Utils.formatToNumber(val<0?0:val));
  }

  public investmentOption: any = 1;

  onRateSelected(rate) {
    if (rate === 1)
      this.investmentOption = 1;
    else if (rate === 2)
      this.investmentOption = 2;
    else if (rate === 3)
      this.investmentOption = 3;

    this.hasRiskTolBeenRan = false;
    this.getLTCData(this.client);
  }

  getRegionVerbiage() {
    let verbiage = `Metro Region(${this.client.clientProfile && this.client.clientProfile.RetirementState ? this.client.clientProfile.RetirementState : "--"})`;
    return this.client.clientProfile.UseNationalAverage ? `National Average` : verbiage;
  }

  getRegionSpouseVerbiage() {
    let verbiage = `Metro Region(${this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].state ? this.client.clientProfile.Spouses[0].state : "--"})`;
    return this.client.clientProfile.UseNationalAverage ? `National Average` : verbiage;
  }

  
  textCheck() {
    if (this.fundingSource) {
      this.showFundingBorder = false;
    } else {
      this.showFundingBorder = true;
    }

    if ((this.annContribution) && (this.annContribution >= 100 && this.annContribution <= 1000000)) {
        this.showAnnContrBorder = false;
      } else {
        this.showAnnContrBorder = true;
    } 

    if (this.startAge) {
      this.showStartAgeBorder = false;
    } else {
      this.showStartAgeBorder = true;
    }

    if (this.endAge) {
      this.showEndAgeBorder = false;
    } else {
      this.showEndAgeBorder = true;
    }

    if (this.inflationRate) {
      this.showInflationBorder = false;
    } else {
      this.showInflationBorder = true;
    }
    if (!this.fundingSource && !this.annContribution && !this.startAge && !this.endAge && !this.inflationRate) {
      this.showFundingBorder = false;
      this.showAnnContrBorder = false;
      this.showStartAgeBorder = false;
      this.showEndAgeBorder = false;
      this.showInflationBorder = false;
    }

  }

  public currentRemainingTotalForRiskTolPort: number = 0;
  public hasRiskTolBeenRan: boolean = false;

  getPortfolioRecommendation() {
    if (JSON.parse(localStorage.getItem('featRiskTolerance')) && !this.hasRiskTolBeenRan) {
      let unfundeHealthCareCost = 0;
      unfundeHealthCareCost = this.currentRemainingTotalForRiskTolPort ? this.currentRemainingTotalForRiskTolPort: 0;
      for(var item of this.fundingItems) {
  
        if (item.remainingUnfunded) {
          unfundeHealthCareCost += item.remainingUnfunded;
        }
      }

      let isClientRetiringFirst = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? Number(this.client.clientProfile.RetirementAge - this.client.clientProfile.currentAge) >= Number(this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) : true;
      let isClientRetired = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ?(Number(this.client.clientProfile.RetirementAge - this.client.clientProfile.currentAge) < 0 ? true: false)  :false ;
			let isSpouseRetired = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ?(Number(this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) < 0 ? true: false)  :false ;
      let clientAge = '';
      let clientRetirementAge = '';
      if((isClientRetired && isSpouseRetired) || (!isClientRetired && !isSpouseRetired)) {
        clientAge = isClientRetiringFirst ? JSON.stringify(this.calculateAge(this.client.client.DOB)) : JSON.stringify(this.calculateAge(this.client.clientProfile.Spouses[0].dob));
        clientRetirementAge = isClientRetiringFirst ? JSON.stringify(this.client.clientProfile.RetirementAge) : this.client.clientProfile.Spouses[0].retirementAge;
      } else if (isClientRetired) {
        clientAge = JSON.stringify(this.calculateAge(this.client.clientProfile.Spouses[0].dob));
        clientRetirementAge = this.client.clientProfile.Spouses[0].retirementAge;
      } else {
        clientAge = JSON.stringify(this.calculateAge(this.client.client.DOB));
        clientRetirementAge = JSON.stringify(this.client.clientProfile.RetirementAge);
      }
      
      var riskTolerance = {
        ClientID: localStorage.getItem('selectedClient'),
        ClientAge: clientAge,
        ClientRetirementAge: clientRetirementAge,
        estimateLifeTimeCostInFuture: JSON.stringify(this.futureTotalCost),
        //estimateLifeTimeCostInFuture: JSON.stringify(this.futureTotalCost),
        unfundedHealthCareCost: JSON.stringify(unfundeHealthCareCost)
      }
  
      this.globalService.getRiskTolerancePortfolio(riskTolerance).subscribe(
        resp => {
          console.log('resp', resp);
          let clientRealAge = JSON.stringify(this.calculateAge(this.client.client.DOB));
          if (resp.PhaseOneRecommend) {
            this.portfolioRecommendationVisible = true;
          }
          this.portfolioRecommendationObject = {
            year: String(isClientRetiringFirst ? this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB) : this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)),
            phase1Portfolio: resp.PhaseOneRecommend,
            phase2Portfolio: resp.PhaseTwoRecommend,
            clientRetirementAge: this.client.clientProfile.RetirementAge,
            spouseRetirementAge: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].retirementAge : '0' ,
            phase1Val: resp.PhaseOneROR,
            phase2Val: resp.PhaseTwoROR,
            clientAge: clientAge,
            spouseAge: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.calculateAge(this.client.clientProfile.Spouses[0].dob): '0' ,
            singleInvestment: (resp.SingleInvestment && resp.SingleInvestment != 0) ? Utils.formatToCurrency(resp.SingleInvestment) : this.portfolioRecommendationObject.singleInvestment,
            unfundedAmount: this.response.LTCGrandTotAmt ? this.response.LTCGrandTotAmt : '$0',
            isMarried: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true: false,
            clientRealAge: clientRealAge,
            clientRealRetirementAge: this.client.clientProfile.RetirementAge,
            spouseFirstName: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].firstName: '',
            spouseLastName: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].lastName: '',
            ltcReport: this.ltcReport,
            user: this.user
          }
          if (Number(clientAge) >= Number(this.client.clientProfile.RetirementAge)) {
            this.isAlreadyRetired = true;
          } else {
            this.isAlreadyRetired = false;
          }

          this.hasRiskTolBeenRan = true;
          //this.getLTCData(this.client, this.partnerActive, true);
          this.getLTCData(this.client, true);
        },
        error => {
          this.error = <any>error;
        });
    }
  }

  getRetirementYear(retirementAge, dob) {
    var currentAge = this.calculateAge(dob);
    var diff = retirementAge - currentAge;
    var year = new Date().getFullYear();
    return year + diff;
  }

  handleAssetManagementModal(event) {
    //clear on call
    localStorage.removeItem('riskTolReportObject');

    //reset
    var report = this.getLTCPDFValues();
    localStorage.setItem('riskTolReportObject', JSON.stringify(report));
    console.log('report');
    console.log(JSON.stringify(report));
    // this.modalService.add('risk-tolerance', {ID: this.client.client.ID, FirstName: this.client.client.FirstName, LastName: this.client.client.LastName});
    this.modalService.add('risk-tolerance', {ID: this.client.client.ID, FirstName: this.client.client.FirstName, LastName: this.client.client.LastName,
      AdvisorFee: this.client.client.ProgramFeePercent, TotalSocialSecurity: 0, FurureTotalCost: Utils.formatToNumber(this.response.LTCGrandTotAmt), PortfolioRecommendationObject: this.portfolioRecommendationObject});
  }
}

